export default __webpack_public_path__ + "static/step7-71774ee45cb4e33a707b8134e8dba4d0.svg";